/* eslint-disable react-hooks/exhaustive-deps */
import { FC, memo, ReactElement, useEffect, useState } from 'react'

type TimerProps = {
  startTime: number
  callBackFunction: () => void
}

const RedirectionTimer: FC<TimerProps> = ({ startTime, callBackFunction }): ReactElement => {
  const [timer, setTimer] = useState(startTime)
  const parent = document.getElementById('redirection-timer-span')?.parentElement

  const updateTimer = () =>
    setTimeout(() => {
      setTimer(timer - 1)
    }, 1000)

  useEffect(() => {
    let timeout: ReturnType<typeof setTimeout>
    if (timer > 0) {
      timeout = updateTimer()
    }
    if (timer === 0 && parent) {
      setTimeout(() => {
        callBackFunction()
      }, 300)
    }

    return () => {
      clearTimeout(timeout)
    }
  }, [timer])

  return (
    <span className="redirection-timer" id="redirection-timer-span">
      {timer}
    </span>
  )
}

export default memo(RedirectionTimer)
